export default {
  colors: {
    blueGreen: '#129598',
    lightGreyBlue: '#9ab9ca',
    charcoalGrey: '#393f4f',
    slate: '#586374',
    pineGreen: '#0a1f30',
    orangeyRed: '#ff3333',
    brightSkyBlue: '#00b4f1',
    warmPink: '#ff5e80',
    cerulean: '#008abf',
    coolGrey: '#8e9499',
    white: '#ffffff',
    lightGrey: '#9fa5af',
    whiteThree: '#f3f3f3',
    whiteEight: '#f8f8f8',
    peacockBlue: '#00639c',
    paleGrey: '#e1ebf6',
    darkCerulean: '#11456b',
    cyprus: '#084748',
    brightTurquoise: '#17D5D5',
    windsor: '#3D2892',
    persianIndigo: '#412396',
    darkTurquoise: '#00D6D6',
    red: '#E76E63',
    dodgerBlue: '#26b3f4',
    blue: '#4fabd2',
    lightBlue: '#f6f9fc',
    dark: '#383e4f',
    orange: '#f3bc87',
    greyValue: '#F7F7F7',
  },
  graphColors: {
    blueGreen: '#129598',
    lightGreyBlue: '#9ab9ca',
    charcoalGrey: '#393f4f',
    slate: '#586374',
    orangeyRed: '#ff3333',
    brightSkyBlue: '#00b4f1',
    warmPink: '#ff5e80',
    cerulean: '#008abf',
    paleGrey: '#e1ebf6',
    darkCerulean: '#11456b',
    persianIndigo: '#412396',
    red: '#E76E63',
    orange: '#f3bc87',
    cyprus: '#084748',
    pineGreen: '#0a1f30',
    darkTurquoise: '#00D6D6',
    coolGrey: '#8e9499',
    white: '#ffffff',
    lightGrey: '#9fa5af',
    whiteThree: '#f3f3f3',
    whiteEight: '#f8f8f8',
    peacockBlue: '#00639c',
    brightTurquoise: '#17D5D5',
    windsor: '#3D2892',
    dodgerBlue: '#26b3f4',
    blue: '#4fabd2',
    lightBlue: '#f6f9fc',
    dark: '#383e4f',
    greyValue: '#F7F7F7',
  },
  tagColor: {
    include: {
      background: 'rgba(0, 138, 191, 0.1)',
      border: '#008abf',
    },
    exclude: {
      background: 'rgba(231, 110, 99, 0.1)',
      border: '#e76e63',
    },
    exacInclude: {
      background: '#ffffff',
      border: '#008abf',
    },
    exacExclude: {
      background: '#ffffff',
      border: '#e76e63',
    },
  },
  spacing: {
    xsmall: '4px',
    small: '8px',
    base: '16px',
    large: '24px',
    xlarge: '32px',
    xxlarge: '56px',
  },
  breakpoint: '1140px',
  font: {
    family: "'Roboto', sans-serif",
    light: '300',
    normal: '400',
    bold: '500',
  },
};
